<div class="full-css-select">
    <select name="language" [(ngModel)]="language" (change)="langChange(language)">
        <option *ngFor="let lang of translate.getLangs()" [value]="lang">
            {{ languages[lang] }}
        </option>
    </select>
</div>